import Button from "@/components/ui/button";
import { useRouter } from "next/router";
import { useState } from "react";
import { Form } from "../FormComps";
import Icon from "../ui/Icon";
import { En, Fa } from "../ui/multilang";

interface Step1Props {
  handleNextStep: () => void;
}

export default function Step1({ handleNextStep }: Step1Props) {
  const { locale } = useRouter();
  const [isPassVisible, setIsPassVisible] = useState<boolean>(false);

  return (
    <>
      <Form.Input name="email" required label={locale === "en" ? "Email" : "ایمیل"} dir="ltr" />
      <Form.Input
        name="password"
        type={isPassVisible ? "text" : "password"}
        required
        label={locale === "en" ? "Password (at least 8 characters)" : "رمز عبور (حداقل ۸ کاراکتر)"}
        suffix={
          <button className="px-1em" type="button" onClick={() => setIsPassVisible((s) => !s)}>
            <span className="sr-only">Show Password</span>
            {!isPassVisible && <Icon name="bf-i-ph-eye" subdued={false} />}
            {isPassVisible && <Icon name="bf-i-ph-eye-closed" subdued={false} />}
          </button>
        }
        dir="ltr"
      />

      <div className="space-y-4">
        <Button type="button" variation="soft-prm" onClick={handleNextStep} className="w-full">
          <En>Next</En>
          <Fa>مرحله بعد</Fa>
        </Button>
      </div>
    </>
  );
}
